import { Component, HostBinding, HostListener, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PrettyUrlsConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { CountItem } from '@frontend/sports/common/core/data-access/sport-model';
import { HooksWireup, OnRouteResolve } from '@frontend/sports/common/core/utils/hooks';
import { CompetitionRoute } from '@frontend/sports/navigation/core/feature/models';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { Tournament } from '@frontend/sports/types/components/tournaments';
import { RxIf } from '@rx-angular/template/if';
import { BehaviorSubject, Subject, map, startWith } from 'rxjs';

import { CalendarService } from '../../../calendar/calendar.service';
import { ErrorComponent } from '../../../common/error/error.component';
import { CompetitionRouteService } from '../../../competition-list/competition-route.service';
import { CompetitionTreeComponent } from '../../../competition-list/competition-tree.component';
import { CompetitionOverview } from '../../../competition-list/services/competition-list.service';
import { ComponentLoaderComponent } from '../../../deferred/component-loader.component';
import { LiveNowLinkRegisterService } from '../../../live-now-item/live-now-link-register.service';

@HooksWireup()
@Component({
    selector: 'ms-competition-list',
    templateUrl: 'competition-list.component.html',
    imports: [CompetitionTreeComponent, ErrorComponent, ComponentLoaderComponent, RxIf],
})
export class CompetitionListComponent extends OnRouteResolve<CompetitionOverview | undefined> implements OnDestroy {
    @HostBinding('class') className = 'region-list-overview';

    sport$ = new BehaviorSubject<CountItem | undefined>(undefined);
    tournaments?: Tournament[];
    context: CompetitionRoute;
    render$ = new Subject();
    showLoader$ = this.render$.pipe(
        map(() => false),
        startWith(true),
    );

    constructor(
        private router: CompetitionRouteService,
        private redirectHelper: RedirectHelperService,
        public sitecore: Sitecore,
        route: ActivatedRoute,
        private liveButton: LiveNowLinkRegisterService,
        private urlConfig: PrettyUrlsConfig,
        private calendar: CalendarService,
    ) {
        super(route);
    }

    @HostListener('swiperight')
    goBack(): void {
        this.redirectHelper.goBack();
    }

    onRouteResolved(model: CompetitionOverview | undefined): void {
        this.sport$.next(model?.sport);

        if (model?.sport) {
            this.context = this.router.params();
            this.tournaments = model.tournaments;

            if (this.showLiveLink()) {
                this.liveButton.addLiveButton(model.sport);
            }
        }
    }

    ngOnDestroy(): void {
        this.liveButton.removeLiveButton();
    }

    private showLiveLink(): boolean {
        if (!this.context.context) {
            return false;
        }

        const interval = this.calendar.getInterval(this.context.context);

        return this.context.context === this.urlConfig.translations.betting && !interval;
    }
}
